import { RewardScene } from '@/types';
import { useReward } from '@/contexts/reward-context';
import { EventLayout } from '@/layouts/event-layout';

export const EventRules = () => {
	const { labels } = useReward();
	return (
		<EventLayout scene={RewardScene.Rule}>
			<div className="reward-terms">
				<div className="reward-terms__detail">
					<h3>{labels?.lbl_RPMemberR}</h3>
					<ol>
						<li>{labels?.lbl_RPMemberR1}</li>
						<li>{labels?.lbl_RPMemberR2}</li>
						<li>{labels?.lbl_RPMemberR3}</li>
						<li>{labels?.lbl_RPMemberR9}</li>
						<li>{labels?.lbl_RPMemberR10}</li>
						<li>{labels?.lbl_RPMemberR11}</li>
						<li>{labels?.lbl_RPMemberR12}</li>
						<li>{labels?.lbl_RPMemberR13}</li>
						<li>{labels?.lbl_RPMemberR14}</li>
						<li>{labels?.lbl_RPMemberR15}</li>
						<li>{labels?.lbl_RPMemberR16}</li>
						<li>{labels?.lbl_RPMemberR17}</li>
					</ol>
				</div>
				<div className="reward-terms__detail">
					<h3>{labels?.lbl_RPRR}</h3>
					<ol>
						<li>{labels?.lbl_RPRR1}</li>
						<li>{labels?.lbl_RPRR9}</li>
						<li>{labels?.lbl_RPRR10}</li>
						<li>{labels?.lbl_RPRR8}</li>
						<li>{labels?.lbl_RPRR11}</li>
						<li>{labels?.lbl_RPRR5}</li>
						<li>{labels?.lbl_RPRR12}</li>
						<li>{labels?.lbl_RPRR6}</li>
						<li>{labels?.lbl_RPRR7}</li>
						<li>{labels?.lbl_RPRR13}</li>
					</ol>
				</div>
			</div>
		</EventLayout>
	);
};
